import { render } from "./Design_Template.vue?vue&type=template&id=2a26267e&scoped=true"
import script from "./Design_Template.vue?vue&type=script&lang=js"
export * from "./Design_Template.vue?vue&type=script&lang=js"

import "./Design_Template.vue?vue&type=style&index=0&id=2a26267e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a26267e"]])

export default __exports__